import type { VehicleTab, VehicleInfo } from '../types';

/**
 * Build a display label for a vehicle (e.g., "New 2026 Honda CR-V")
 * @param vehicle - Vehicle info object
 * @returns Formatted vehicle label
 */
export const buildVehicleLabel = (vehicle: VehicleInfo | undefined): string => {
    if (!vehicle) return '';
    const isNew = (vehicle.condition || '').toLowerCase() === 'new';
    const conditionLabel = isNew ? 'New' : 'Used';
    const name = [vehicle.year, vehicle.make, vehicle.model].filter(Boolean).join(' ');
    return [conditionLabel, name].filter(Boolean).join(' ').trim();
};

/**
 * Convert a vehicle info object to a VehicleTab for UI display.
 * Returns undefined if no VIN is present.
 * @param vehicle - Vehicle info object
 * @param isPrimary - True if this is the primary vehicle, false for scenario vehicles
 * @returns VehicleTab or undefined
 */
export const toVehicleTab = (vehicle: VehicleInfo | undefined, isPrimary?: boolean): VehicleTab | undefined => {
    if (!vehicle?.vin) {
        return undefined;
    }
    return {
        id: vehicle.vin,
        label: buildVehicleLabel(vehicle),
        combinedFuelEconomy: vehicle.combinedFuelEconomy,
        isPrimary
    };
};
